import translation from "../../../utils/translation";

const handleMaritalStatusFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.maritalStatus = action.payload.data;
};

const handleTimeZoneFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.timeZones = action.payload?.data;
};

const handleNumberCounterFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.numberCounter = action.payload.data;
};

const handleReligionListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.religionList = action.payload.data;
};

const handleFlexibleDateFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.flexibleDates = action.payload.data;
};

const handleContractStatusFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.contractStatus = action.payload.data;
};

const handleMainSkillsFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.mainSkills = action.payload.data;
};

const handleCookingListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.cookingList = action.payload.data;
};

const handleGetPetListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.petList = action.payload.data;
}

const handleCourseListFulfilled = (state, action) => {
    state.status = 'succeeded';
    if (action?.payload?.data && action?.payload?.data?.length > 0) {
        state.courseList = [
            { id: 0, name_en: "None", name: translation("key_none") },
            ...action.payload.data
        ];
    }

};
const handleEducationListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.educationList = action.payload.data;
};
const handleAccomodationFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.accommodations = action.payload.data;
};
const handleExpectedSalaryFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.expectedSalaryList = action.payload.data;
};
const handleLanguageListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.languages = action.payload.data;
};
const handleDayOffListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.dayOffList = action.payload.data;
};

const handleInterviewDayListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.interviewDayList = action.payload.data;
}
const handleSpokenLanguageListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.spokenLanguages = action.payload.data;
    state.message = action.payload.message;

};
const handleGenderListListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.genderList = action.payload.data;
}

const handleHeightListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.heightList = action.payload.data;
}

const handleChildCareAgeListFulfilled = (state, action) => {
    state.childCareAgeList = action.payload.data;
    state.status = 'succeeded';
};

const handleWorkerLeavingReasonFulfilled = (state, action) => {
    state.leavingReasons = action.payload.data;
    state.status = 'succeeded';
};

const handleChildCareDutiesFulfilled = (state, action) => {
    state.childCareDuties = action.payload.data;
    state.status = 'succeeded';
};

const handleElderlyCareDutiesFulfilled = (state, action) => {
    state.elderlyCareDuties = action.payload.data;
    state.status = 'succeeded';
};

const handleHouseholdChoresFulfilled = (state, action) => {
    state.householdChores = action.payload.data;
    state.status = 'succeeded';
};

const handleSpokenLanguageWorkerListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.spokenLanguagesList = action.payload.data;
}

const handleSpokenLanguageEmployerListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.spokenLanguagesListEmp = action.payload.data;
}

const handleFetchNotificationListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.notificationList = action.payload.data;
}

const handlefetchContractWorkerStatusFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.workerContractStatus = action.payload.data;
}

const handleFetchNotificationUnreadCountFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.notificationUnreadCount = action.payload?.total || 0;
}

const handleShiftExperienceFulfilled = (state) => {
    state.status = 'succeeded';
}

export {
    handleMaritalStatusFulfilled,
    handleTimeZoneFulfilled,
    handleNumberCounterFulfilled,
    handleReligionListFulfilled,
    handleFlexibleDateFulfilled,
    handleContractStatusFulfilled,
    handleMainSkillsFulfilled,
    handleCookingListFulfilled,
    handleGetPetListFulfilled,
    handleCourseListFulfilled,
    handleEducationListFulfilled,
    handleAccomodationFulfilled,
    handleExpectedSalaryFulfilled,
    handleLanguageListFulfilled,
    handleDayOffListFulfilled,
    handleInterviewDayListFulfilled,
    handleSpokenLanguageListFulfilled,
    handleGenderListListFulfilled,
    handleHeightListFulfilled,
    handleChildCareAgeListFulfilled,
    handleChildCareDutiesFulfilled,
    handleElderlyCareDutiesFulfilled,
    handleHouseholdChoresFulfilled,
    handleWorkerLeavingReasonFulfilled,
    handleSpokenLanguageWorkerListFulfilled,
    handleSpokenLanguageEmployerListFulfilled,
    handleFetchNotificationListFulfilled,
    handlefetchContractWorkerStatusFulfilled,
    handleFetchNotificationUnreadCountFulfilled,
    handleShiftExperienceFulfilled
};
